import { useState } from "react";
import CustomAudioRecorder from "./components/CustomAudioRecorder/CustomAudioRecorder";
import { useEffect } from "react";
import { useTranslationSetup } from "./utils/useTranslationSetup.js";
import AudioSizeShortError from "./components/AudioSizeShortError/AudioSizeShortError.js";
import AssessmentSaveAudioConfirmationDrawer from "./components/AssessmentSaveAudioConfirmationDrawer/AssessmentSaveAudioConfirmationDrawer.js";
import useAudioRecorderV3 from "./utils/useAudioRecorderV3.js";

const AudioRecorder = ({
  hideSlider,
  setHideSlider,
  setHideArrow,
  audioBlobForAudioPlayer,
  setAudioBlobForAudioPlayer,
  processedData,
  setProcessedData,
  assessmentId,
  setAssessmentId,
  studentName,
  setStudentName,
  orfResultStatus,
  setOrfResultStatus,
  selectedLaguage,
  setSelectedLaguage,
  saveClicked,
  setSaveClicked,
  isAudioUploading,
  setAudioUploading,
  uploadAudioStatus,
  setUploadAudioStatus,
  setActiveScreen,
}) => {
  const {
    isRecording,
    isStopped,
    isPaused,
    isResumed,
    audioBlob,
    recordingError,
    duration,
    setAudioBlob,
    startRecording,
    stopRecording,
    pauseRecording,
    resumeRecording,
  } = useAudioRecorderV3();
  const [openDialogForError, setOpenDialogForError] = useState(false);
  const [
    openAssessmentSaveAudioConfirmationDrawer,
    setAssessmentSaveAudioConfirmationDrawer,
  ] = useState(false);
  const [showSaveResultDialog, setShowSaveResultDialog] = useState(false);
  const { t } = useTranslationSetup();

  if (isRecording) {
    setHideArrow(true);
  } else {
    setHideArrow(false);
    setAudioBlobForAudioPlayer(audioBlob);
  }

  useEffect(() => {
      if (duration === undefined || (duration !== null && duration <= 5)) {
        setOpenDialogForError(true);
      }

  }, [duration]);

  return (
    <>
      <AudioSizeShortError
        isDialogOpen={openDialogForError}
        setDialogOpen={setOpenDialogForError}
        warningHeading={t("audio_size_small_heading")}
        warningMessage={t("audio_size_small_text")}
        onClickRecordAgain={() => {
          setOpenDialogForError(false);
          setHideSlider(false);
          setAudioBlobForAudioPlayer(null);
          setAudioBlob(null);
        }}
        t={t}
      />

      <AssessmentSaveAudioConfirmationDrawer
        openDrawer={openAssessmentSaveAudioConfirmationDrawer}
        setOpenDrawer={setAssessmentSaveAudioConfirmationDrawer}
        setActiveScreen={setActiveScreen}
        audioBlob={audioBlobForAudioPlayer}
        setAudioBlob={setAudioBlobForAudioPlayer}
        onClickSaveButton={() => {
          setAudioUploading(true);
          setShowSaveResultDialog(true);
          setSaveClicked(true);
          setAssessmentSaveAudioConfirmationDrawer(false);
        }}
        onClickRetakeButton={() => {
          setAssessmentSaveAudioConfirmationDrawer(false);
          setOpenDialogForError(false);
          setHideSlider(false);
          setAudioBlobForAudioPlayer(null);
          setAudioBlob(null);
          setAudioUploading(false);
          setShowSaveResultDialog(false);
          setSaveClicked(false);
        }}
      />

      <CustomAudioRecorder
        isRecording={isRecording}
        isStopped={isStopped}
        isPaused={isPaused}
        isResumed={isResumed}
        audioBlob={audioBlob}
        recordingError={recordingError}
        setAudioBlob={setAudioBlob}
        startRecording={startRecording}
        stopRecording={stopRecording}
        pauseRecording={pauseRecording}
        resumeRecording={resumeRecording}
        hideSlider={hideSlider}
        setHideSlider={setHideSlider}
        audioBlobForAudioPlayer={audioBlobForAudioPlayer}
        setAudioBlobForAudioPlayer={setAudioBlobForAudioPlayer}
        processedData={processedData}
        setProcessedData={setProcessedData}
        assessmentId={assessmentId}
        setAssessmentId={setAssessmentId}
        studentName={studentName}
        setStudentName={setStudentName}
        orfResultStatus={orfResultStatus}
        setOrfResultStatus={setOrfResultStatus}
        selectedLaguage={selectedLaguage}
        setSelectedLaguage={setSelectedLaguage}
        saveClicked={saveClicked}
        setSaveClicked={setSaveClicked}
        isAudioUploading={isAudioUploading}
        setAudioUploading={setAudioUploading}
        uploadAudioStatus={uploadAudioStatus}
        setUploadAudioStatus={setUploadAudioStatus}
        openAssessmentSaveAudioConfirmationDrawer={
          openAssessmentSaveAudioConfirmationDrawer
        }
        setAssessmentSaveAudioConfirmationDrawer={
          setAssessmentSaveAudioConfirmationDrawer
        }
        showSaveResultDialog={showSaveResultDialog}
        setShowSaveResultDialog={setShowSaveResultDialog}
        setActiveScreen={setActiveScreen}
      />
    </>
  );
};

export default AudioRecorder;
